import { debounce, headerHeight } from './helpers'

const sf = {
  forceDisable: false,
  hasInitialized: false,
}

sf.init = () => {
  sf.siteContent = document.querySelector('[data-above-sticky-footer]')
  sf.footer = document.querySelector('[data-sticky-footer]')
  if (!sf.siteContent || !sf.footer) return
  const trigger = document.querySelector('[data-footer-trigger]')
  const observer = new IntersectionObserver(
    entries =>
      entries.forEach(entry => {
        sf.footer.style.opacity = entry.isIntersecting ? '' : '0'
        sf.footer.style.pointerEvents = entry.isIntersecting ? '' : 'none'
      }),
    { rootMargin: '2000px 0px 200px' }
  )
  const observer2 = new IntersectionObserver(
    entries =>
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          sf.footer
            .querySelectorAll('[data-scroll-animation]')
            .forEach(el => el.classList.add('animate'))
        }
      }),
    { rootMargin: '0px 0px -200px' }
  )
  observer.observe(trigger)
  observer2.observe(trigger)
  const debouncedAdjust = debounce(sf.adjust, 200)
  window.addEventListener('resize', debouncedAdjust)
  sf.adjust()
  sf.hasInitialized = true
}

sf.adjust = () => {
  const fits =
    window.innerHeight >= sf.footer.clientHeight + headerHeight() &&
    !sf.forceDisable
  sf.siteContent.style.marginBottom = `${fits ? sf.footer.clientHeight : 0}px`
  sf.footer.classList.toggle('sticky-footer', fits)
}

sf.checkIfDisabled = container => {
  if (!sf.hasInitialized) return
  sf.forceDisable = !!container.querySelector('[data-disable-sticky-footer]')
  sf.adjust()
}

export default sf
